import { storeToRefs } from 'pinia'

import BetByMenuData from '@/assets/common/betby'
import { useMainStore } from '@/stores/main'

export function useBetbyMenu() {
  const { userInfo } = useUserInfo({ autoInit: false })
  const { getFrontCdnUrl } = useCdnAssets()
  const { getWithdrawRule } = storeToRefs(useMainStore())

  const buildBetbySubItems = (parentLevel) =>
    BetByMenuData.map((subItem, idx) => ({
      ...subItem,
      categoryId: `betby-${idx}`,
      image: getFrontCdnUrl(`images/side/${subItem.icon}.png`),
      level: (parentLevel ?? 0) + 1,
      isBetby: true,
    }))

  const decorateMenuItem = (item) => {
    const disabled =
      item.isBonus && (userInfo.value.withdraw_rule?.indexOf('FREE_LIMIT_') === -1 || (getWithdrawRule.value?.limitGameDetail || []).length === 0)

    const isBetbyItem = /betby/i.test(item.name?.['en-US'] || '') || /betby/i.test(item.link || '')
    if (isBetbyItem) {
      return {
        ...item,
        disabled,
        isGame: false,
        link: item.link || '/sportsbook',
        sub: buildBetbySubItems(item.level),
      }
    }

    if (Array.isArray(item.sub) && item.sub.length > 0) {
      return { ...item, disabled, sub: item.sub.map(decorateMenuItem) }
    }

    return { ...item, disabled }
  }

  return { decorateMenuItem }
}
